import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import createVuetifyWithThemeColor from "./plugins/vuetify";
import VueApollo from "vue-apollo";
import apolloClient from "./graphql/client";
import VueMoment from "vue-moment";
import moment from "moment";
import i18n from "./i18n";
import VueVideoPlayer from "vue-video-player";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import "./filters";
import client from "./graphql/client";
import AppSettingsQuery from "./graphql/queries/appSettings/AppSettings.gql";

import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "fontsource-roboto/index.css";

async function queryAppSettings() {
  const response = await client.query({ query: AppSettingsQuery });
  return response.data.appSettings;
}

async function initApp() {
  moment.locale("et");

  Vue.use(Vuex);
  Vue.use(VueApollo);
  Vue.use(VueMoment, { moment });
  Vue.use(VueVideoPlayer);

  Vue.config.productionTip = false;

  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
  });

  const appSettings = await queryAppSettings();
  store.dispatch("save_app_settings", appSettings);

  if (!store.state.locale) {
    store.commit("change_locale", appSettings.defaultLocale);
  }

  if (process.env.NODE_ENV != "development") {
    Sentry.init({
      Vue,
      dsn:
        "https://69478727c3c142738311c95402fc9619@o4504453142544384.ingest.sentry.io/4504453231869952",
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracePropagationTargets: [
            "safetyportal.whyflow.ee",
            "eeraksrv04.jwinc.jeld-wen.com",
            /^\//,
          ],
        }),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.1,
    });

    Sentry.setUser(store.state.me ? store.state.me.id : undefined);
  }

  const vuetify = createVuetifyWithThemeColor(
    (appSettings && appSettings.themePrimaryColor) || "#126DF5"
  );
  new Vue({
    vuetify,
    router,
    store,
    apolloProvider,
    i18n,
    render: (h) => h(App),
    created() {
      i18n.locale = store.state.locale;
    },
  }).$mount("#app");
}

initApp();
